// Utility to load Google AdSense script according to user's consent
// Replace CA_PUB_ID with your real AdSense client ID, e.g. "ca-pub-1234567890123456"
// When `personalized` is false, the script is loaded with npa=1 to request
// non-personalized ads as recommended by Google.

export const loadAdsense = (personalized = true) => {
  if (typeof window === 'undefined') return;

  // If the script is already present, don't inject it again
  const existing = document.getElementById('adsense-script');
  if (existing) {
    // If we previously loaded non-personalized and user finally consents,
    // we could reload the script without npa=1. For simplicity, we keep
    // the first loaded mode. A full refresh will load the correct variant.
    return;
  }

  const CA_PUB_ID = 'ca-pub-5044163678723281'; // TODO: replace with your AdSense ID
  const src = personalized
    ? `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${CA_PUB_ID}`
    : `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${CA_PUB_ID}&npa=1`;

  const script = document.createElement('script');
  script.id = 'adsense-script';
  script.src = src;
  script.async = true;
  script.crossOrigin = 'anonymous';
  document.head.appendChild(script);

  script.onload = () => {
    if (window.adsbygoogle && Array.isArray(window.adsbygoogle)) {
      window.adsbygoogle.push({});
    }
  };
};
